import React from "react";
import styled from "styled-components";

import {
  EntityMenuItem,
  ReferencePickerPlugin,
} from "@adsk/acc-reference-picker";
import { useCurrentProjectId } from "@adsk/alloy-provider";
import { FanIcon } from "@adsk/alloy-react-icon";
import Theme from "@adsk/alloy-react-theme";

import {
  SystemWithCategoryAndStatus,
  UNSPECIFIED_STATUS_COLOR_KEY,
} from "../../models";
import getSystemUrl from "../helpers/getSystemUrl";
import { StatusColorIndicator } from "../shared/DataView/StatusCell";

const Label = styled.div`
  align-items: center;
  display: inline-flex;
`;

const Name = styled.div<{ isUnspecified: boolean }>`
  margin-left: 3px;

  ${(props) =>
    props.isUnspecified &&
    `color: ${Theme.colors.charcoal500}; font-style: italic;`}
`;

const SmallStatusColorIndicator = styled(StatusColorIndicator)`
  width: 3px;
  height: 16px;
  cursor: default;
`;

const SystemsEntityMenuItem: Exclude<
  ReferencePickerPlugin<SystemWithCategoryAndStatus>["EntityMenuItem"],
  undefined
> = ({ entity, ...rest }) => {
  const projectId = useCurrentProjectId();
  const { id, name, status } = entity;
  const label = (
    <Label>
      <SmallStatusColorIndicator
        color={status ? status.color : UNSPECIFIED_STATUS_COLOR_KEY}
      />
      <Name isUnspecified={!status}>{name}</Name>
    </Label>
  );

  return (
    <EntityMenuItem
      link={projectId ? getSystemUrl(projectId, id) : undefined}
      label={label}
      renderIcon={FanIcon.renderIcon}
      {...rest}
    />
  );
};

export default SystemsEntityMenuItem;
